"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _datePickers = require("@vds-core/date-pickers");
var _calendars = require("@vds/calendars");
var _tooltips = require("@vds/tooltips");
var _layout = require("@vds-tokens/layout");
var _InputField = require("../InputField");
function _errorBackgroundColor(error, inverted, disabled) {
  return "transparent";
}
var propTypes = {
  /**
   * @ignore If passed, a background color will be passed to the input
   */
  errorBackgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string]),
  /**
   * @ignore string representing the input's border bottom width
   */
  borderBottomWidth: _propTypes["default"].string,
  /**
   * @ignore If true, sets the error state border bottom with to heavy
   */
  heavyErrorBorder: _propTypes["default"].bool,
  /**
   * The format of the DatePicker field, can be 'MM/DD/YY', 'MM/DD/YYYY', or 'Month, Date, Year'.
   */
  format: _propTypes["default"].oneOf(["MM/DD/YY", "Month, Date, Year", "MM/DD/YYYY", "M/D/YYYY"]),
  /**
   * Component will render in Inverted state.
   */
  inverted: _propTypes["default"].bool,
  /**
   * @deprecated
   * The beginning of a period thal shall be displayed by the Calendar. If no value is provided, the currect date (new Date()) will be used.
   */
  activeStartDate: _propTypes["default"].instanceOf(Date),
  /**
   * @deprecated
   * Callback used to get the selected date from DatePicker.
   */
  handleDatePick: _propTypes["default"].func,
  /**
   * @deprecated
   * If provided, the calendar will allow a selection to be made from this date forward. Defaults to today.
   */
  pastDatesDisabled: _propTypes["default"].bool,
  /**
   * String, array or node containing the title of the TooltipDialog
   */
  tooltipTitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].node]),
  /**
   * String, array or node containing the body content of the TooltipDialog
   */
  tooltipContent: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].node])
};
var defaultProps = {
  format: "Month, Date, Year",
  pastDatesDisabled: false,
  inverted: false
};

// Extract calendar's props from core to re-apply inverted
var _renderCalendar = function _renderCalendar(calendarCoreProps) {
  return /*#__PURE__*/_react["default"].createElement(_calendars.Calendar, (0, _extends2["default"])({}, calendarCoreProps, {
    inverted: calendarCoreProps.surface === "dark"
  }));
};

// Extract inputs's props from core to re-apply inverted to 1.x Inputs
var _renderInputField = function _renderInputField(inputCoreProps) {
  return /*#__PURE__*/_react["default"].createElement(_InputField.InputField, (0, _extends2["default"])({}, inputCoreProps, {
    inverted: inputCoreProps.surface === "dark"
  }));
};
var DatePicker = function DatePicker(props) {
  return /*#__PURE__*/_react["default"].createElement(_datePickers.DatePicker, (0, _extends2["default"])({
    maxWidth: 596
  }, props, {
    minDate: props.pastDatesDisabled !== undefined ? props.pastDatesDisabled ? new Date() : null : props.minDate,
    onChange: props.handleDatePick || props.onChange,
    selectedDate: props.activeStartDate !== undefined ? props.activeStartDate : props.selectedDate,
    surface: props.inverted ? "dark" : "light",
    heavyErrorBorder: true,
    errorBackgroundColor: _errorBackgroundColor,
    borderBottomWidth: _layout.LayoutTokens.space["1X"].value,
    dateFormat: props.format,
    dateSelectionSize: 32,
    hideCurrentDateIndicator: true,
    indicators: undefined,
    Calendar: _renderCalendar,
    InputField: _renderInputField
  }));
};
DatePicker.propTypes = propTypes;
DatePicker.defaultProps = defaultProps;
var _default = exports["default"] = DatePicker;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/inputs/dist/cjs/components/Calendar/DatePicker.js
// module id = 1447
// module chunks = 0